import { ACTIVITY_STATES } from 'constants/enums'
import { get } from 'lodash'

export default function(awards) {
  const majorActivityNeeded = get(awards, 'data.majorActivityNeeded')
  const activities = get(awards, 'data.activities')

  const majorAwards = activities && activities
      .find(activity => activity.isMajor && activity.activityState.value !== ACTIVITY_STATES.setup.id)

  return majorActivityNeeded && !majorAwards
}
